import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { HomeComponent } from './home/home.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { LoginRegComponent } from './login-reg/login-reg.component';
import { OrderconfirmationComponent } from './orderconfirmation/orderconfirmation.component';
import { CheckoutComponent } from './shopping-cart/checkout/checkout.component';
import { ShoppingCartComponent } from './shopping-cart/shopping-cart.component';
import { TrackComponent } from './track/track.component';

const routes: Routes = [
	{
		path: '',
		// canActivate:[AuthGuard],
		component: MainLayoutComponent,
		children: [
			{
				path: '',
				redirectTo: '/home',
				pathMatch: 'full',
			},
			{
				path: 'home',
				component: HomeComponent
			},
			{
				path: 'login',
				component: LoginRegComponent
			},
			{
				path: 'register',
				component: LoginRegComponent
			},
			{
				path: 'shopping-cart',
				component: ShoppingCartComponent
			},
			{
				path: 'checkout',
				component: CheckoutComponent
			},
			{
				path: 'order-confirmation',
				component: OrderconfirmationComponent
			},
			{
				path: 'contact-us',
				component: ContactUsComponent
			},
			// {
			// 	path: 'track',
			// 	component: TrackComponent
			// },
			{
				path: 'profile',
				loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
			},
			{
				path: 'about-us',
				loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule)
			},
			{
				path: 'products',
				loadChildren: () => import('./product/product.module').then(m => m.ProductModule)
			},
			{
				path: 'profile',
				loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
			},
			{
				path: 'new_booking',
				// canActivate: [IsAuthGuard],
				loadChildren: () => import('./booking/booking.module').then(m => m.BookingModule)
			},
			{
				path: 'bookings',
				// canActivate: [IsAuthGuard],
				loadChildren: () => import('./booking/booking.module').then(m => m.BookingModule)
			},
			{
				path: 'orders',
				// canActivate: [IsAuthGuard],
				loadChildren: () => import('./order/order.module').then(m => m.OrderModule)
			},
			{
				path: 'address_book',
				// canActivate: [IsAuthGuard],
				loadChildren: () => import('./address-book/address-book.module').then(m => m.AddressBookModule)
			},
		]
	}
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
